export enum GrauInstrucaoEnum {
    Analfabeto = 1, 
    FundamentalIncompleto = 2, 
    FundamentalCompleto5Ano = 3, 
    FundamentalIncompleto6Ao9Ano = 4, 
    FundamentalCompleto = 5, 
    MedioIncompleto = 6, 
    MedioCompleto = 7, 
    SuperiorIncompleto = 8, 
    SuperiorCompleto = 9, 
    PosGraduacaoCompleta = 10, 
    MestradoCompleto = 11, 
    DoutoradoCompleto = 12, 
  }